function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shopping-cart",
  transform: "translate(0.75 0.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "shopping-cart-2",
  "data-name": "shopping-cart"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M7.2,19.2a2.4,2.4,0,1,0,2.4,2.4A2.407,2.407,0,0,0,7.2,19.2ZM0,0V2.4H2.4l4.32,9.12L5.04,14.4a4.264,4.264,0,0,0-.24,1.2A2.407,2.407,0,0,0,7.2,18H21.6V15.6H7.68a.258.258,0,0,1-.24-.24v-.12L8.52,13.2H17.4A2.188,2.188,0,0,0,19.44,12l4.32-7.8A.661.661,0,0,0,24,3.6a1.134,1.134,0,0,0-1.2-1.2H5.04L3.96,0ZM19.2,19.2a2.4,2.4,0,1,0,2.4,2.4A2.407,2.407,0,0,0,19.2,19.2Z",
  fill: "#0D47A1",
  stroke: "#fff",
  strokeWidth: 1.5
})));

var SvgCart120 = function SvgCart120(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.5,
    height: 25.5,
    viewBox: "0 0 25.5 25.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart120, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart1-20.8f626896.svg";
export { ForwardRef as ReactComponent };